interface RevHubImagoProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  className?: string;
  colorRev?: string;
  colorHub?: string;
  bgColor?: string;
}

const RevHubImago: React.FC<RevHubImagoProps> = ({
  width = '32px',
  height = '32px',
  className,
  colorRev = '#646BFF',
  colorHub = '#010550',
  bgColor = '#FFFFFF',
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    {...rest}
    className={className}
  >
    <path
      fill={colorRev}
      d="M32,16c0,8.8-7.2,16-16,16S0,24.8,0,16,7.2,0,16,0s16,7.2,16,16Z"
    />
    <path
      fill={colorHub}
      d="M27.2,21.5c-.4,0-.7,0-1-.1-.3,0-.5-.2-.8-.4-.2-.2-.4-.4-.6-.6l-.3.9h-2v-10.7h2.2v4.2c.2-.3.5-.6.9-.8.4-.2.8-.3,1.4-.3s1.3.2,1.8.5c.5.3,1,.8,1.3,1.4.3.6.5,1.3.5,2s-.2,1.4-.5,2c-.3.6-.7,1.1-1.3,1.4-.5.3-1.1.5-1.8.5ZM26.6,19.5c.4,0,.7,0,1-.3.3-.2.5-.4.7-.7.2-.3.2-.6.2-1s0-.7-.2-1c-.2-.3-.4-.5-.7-.7-.3-.2-.6-.3-1-.3s-.7,0-1,.3c-.3.2-.5.4-.7.7-.2.3-.2.6-.2,1s0,.7.2,1c.2.3.4.5.7.7.3.2.6.3,1,.3ZM16.1,21.5c-.6,0-1.2-.1-1.6-.4-.4-.3-.8-.6-1-1.1-.2-.5-.3-1.1-.3-1.8v-4.3h2.2v4.1c0,.6.1,1,.3,1.3.2.3.6.4,1.1.4s.6,0,.8-.2c.2-.1.4-.3.6-.6.1-.3.2-.6.2-1v-4h2.2v7.5h-2l-.2-1.2c-.2.4-.5.7-1,1-.4.2-.9.4-1.5.4ZM9,10.9v4.2h-4.3v-4.2h-2.2v10.4h2.2v-4.4h4.3v4.4h2.2v-10.4h-2.2Z"
    />
    <path
      fill={bgColor}
      d="M19.7,13l-.9-2.5h.8l.6,1.8.6-1.8h.8l-.9,2.5h-.9ZM18.5,11.1c-.1-.2-.3-.3-.4-.4-.2-.1-.4-.2-.7-.2s-.5,0-.7.2c-.2.1-.3.3-.5.5-.1.2-.2.4-.2.7s0,.5.2.7c.1.2.3.3.5.4.2.1.4.2.7.2s.4,0,.5-.1c.2,0,.3-.2.4-.3.1-.1.2-.3.2-.4h-.8c0,0,0,.1-.2.2,0,0-.2,0-.3,0s-.2,0-.3,0c0,0-.1-.1-.2-.2,0,0,0-.1,0-.2h1.8s0,0,0-.1c0,0,0,0,0-.1,0-.2,0-.4-.2-.6ZM16.8,11.6c0,0,0-.1,0-.2,0,0,.1-.2.2-.2,0,0,.2,0,.3,0s.3,0,.3.1c0,0,.1.2.2.3h-1ZM15.7,13l-.7-1.4s0,0,.1,0c.2,0,.3-.2.4-.4,0-.2.1-.3.1-.5s0-.4-.1-.5c0-.2-.2-.3-.4-.4-.2,0-.4-.1-.7-.1h-1.3v3.5h.7v-1.3h.4l.6,1.3h.8ZM13.9,10.2h.6c.2,0,.3,0,.4.1,0,0,.1.2.1.4s0,.3-.1.4c0,0-.2.1-.4.1h-.6v-1Z"
    />
  </svg>
);

export default RevHubImago;
